import { getCurrentBrand } from "./config";

/**
 * Get brand information for API calls
 * @returns {Object} Brand information object
 */
export const getBrandInfo = () => {
  const brand = getCurrentBrand();

  return {
    brand,
    isClivet: brand === "clivet",
    isProlux: brand === "prolux",
    isTermovent: brand === "termovent",
  };
};

/**
 * Get brand-specific configuration
 * @returns {Object} Brand-specific configuration
 */
export const getBrandConfig = () => {
  const brand = getCurrentBrand();

  const brandConfigs = {
    termovent: {
      name: "Termovent",
      apiPrefix: "termovent",
      defaultLocation: "Belgrade, Serbia",
    },
    clivet: {
      name: "Clivet",
      apiPrefix: "clivet",
      defaultLocation: "Feltre, Italy",
    },
    prolux: {
      name: "Prolux",
      apiPrefix: "prolux",
      defaultLocation: "Arbon, Switzerland",
    },
  };

  return brandConfigs[brand] || brandConfigs.termovent;
};

/**
 * Add brand header to axios request config
 * @param {Object} config - Axios request config
 * @returns {Object} Updated config with brand header
 */
export const addBrandHeader = (config = {}) => {
  return {
    ...config,
    headers: {
      ...config.headers,
      "X-Brand": getCurrentBrand(),
    },
  };
};

/**
 * Add brand prefix to translation key
 * @param {string} translationKey - Translation key to prefix
 * @returns {string} Prefixed translation key based on current brand
 */
export const brandTranslation = (translationKey) => {
  const brand = getCurrentBrand();
  const prefix =
    {
      clivet: "clivet",
      prolux: "prolux",
      termovent: "",
    }[brand] || "";

  return prefix ? `${prefix}.${translationKey}` : translationKey;
};
